export default __webpack_public_path__ + "static/media/release.a5f85689.png";